import { Component } from '@theme/component';

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll('table').forEach(this.#formatTable);
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte-table-wrapper');
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }
}

if (!customElements.get('rte-formatter')) {
  customElements.define('rte-formatter', RTEFormatter);
}

const upgradeCachedReviewImages = () => {
  document.querySelectorAll('.ab-judgeme-reviews .ab-review-placeholder__image').forEach((image) => {
    const source = image.getAttribute('src') || image.currentSrc || '';
    if (!source) return;

    const highResUrl = source
      .replace(/\\u0026/g, '&')
      .replace(/&amp;/g, '&')
      .replace(/([?&])width=\d+/g, '$1width=1600');

    image.setAttribute('src', highResUrl);
    image.setAttribute('srcset', `${highResUrl} 1600w`);
    image.setAttribute('sizes', '(max-width: 749px) 50vw, (max-width: 1279px) 33vw, 320px');
    image.setAttribute('loading', 'eager');
    image.setAttribute('decoding', 'async');
    image.dataset.abReviewPhotoHd = 'asset-20260613';
  });
};

upgradeCachedReviewImages();
document.addEventListener('DOMContentLoaded', upgradeCachedReviewImages);
window.addEventListener('load', upgradeCachedReviewImages);
window.setTimeout(upgradeCachedReviewImages, 1000);
window.setTimeout(upgradeCachedReviewImages, 3000);
